/* Floating cart button: opens Dawn's cart drawer (no navigation) and keeps its
   count badge in sync with the header cart bubble, which Dawn re-renders on any
   cart change. */
(function () {
  var fab = document.querySelector('.cart-fab');
  if (!fab) return;

  var countEl = fab.querySelector('[data-cart-fab-count]');

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(fab);
    } else {
      // Fallback: go to the cart page if the drawer isn't present.
      window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    }
  }

  fab.addEventListener('click', openDrawer);

  // Sync the badge with the header cart count. Dawn updates #cart-icon-bubble
  // via the Section Rendering API whenever the cart changes; mirror it.
  function readHeaderCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) return parseInt(bubble.textContent.trim(), 10) || 0;
    // No bubble element means an empty cart.
    return document.querySelector('#cart-icon-bubble .cart-count-bubble') ? 0 : 0;
  }

  function setCount(n) {
    if (!countEl) return;
    var current = parseInt(countEl.textContent.trim(), 10) || 0;
    countEl.textContent = n;
    fab.classList.toggle('cart-fab--empty', n === 0);
    if (n !== current && n > 0) {
      countEl.classList.add('is-bumped');
      setTimeout(function () {
        countEl.classList.remove('is-bumped');
      }, 220);
    }
  }

  var bubbleHost = document.querySelector('#cart-icon-bubble');
  if (bubbleHost) {
    setCount(readHeaderCount());
    var mo = new MutationObserver(function () {
      setCount(readHeaderCount());
    });
    mo.observe(bubbleHost, { childList: true, subtree: true, characterData: true });
  }
})();
